import Header from '../components/Header';
import Footer from '../components/Footer';
import ExtraContent from '../components/ExtraContent';
import AvatarMobile from '../components/AvatarMobile';
import '../styles/sideBySide.css';
import '../styles/HomePage.css';
import '../styles/Adaptive.css';

const HomePage = () => {
  return (
    <div >
      <div id="mainContent" className="mainContent">
        <Header currentPage={"home"} />
        <AvatarMobile />
        <div className="introContent">
          <div className="title"><strong>Всем привет!</strong></div>
          <div className="title"><strong>Меня зовут Илья Ширко!</strong></div>
          
          <div>
            <p className="smallTalk">Я full-stack разработчик.</p>
            <p className="smallTalk">Основные мои специализации - Python, React и Devops.</p>
            <p className="smallTalk">Профессиональный, иногда веселый и почти всегда доброжелательный.</p>
            <p className="smallTalk">Это мой персональный сайт, мое портфолио, моя автобиография.</p>
            <p className="smallTalk">Добро пожаловать!</p>
            <br />
          </div>
        </div>
        
        <Footer />
      </div>
      
      <ExtraContent />
    </div>
  );
};

export default HomePage; 